import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const BASE_URL = window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8003'
    : 'https://rbmchemicals.com';

const SubCategoryPage = () => {
    const { subCategory } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);

    // BASE_URL ensure karein images ke liye
    const BASE_URL = "https://rbmchemicals.com";

    useEffect(() => {
        setLoading(true);
        // FIX: Path ko api/urls.py se match kiya
        fetch(`/api/get_products_by_subcategory/${encodeURIComponent(subCategory)}/`)
            .then((res) => {
                if (!res.ok) throw new Error("Failed to fetch");
                return res.json();
            })
            .then((data) => {
                // Agar API list return kar raha hai, toh pehla item lein
                setProduct(Array.isArray(data) ? data[0] : data);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Fetch Error:", err);
                setLoading(false);
            });
    }, [subCategory]);

    if (loading) return <div className="text-center py-20 text-xl">Loading...</div>;
    if (!product) return <div className="text-center py-20 text-xl text-red-600">Product not found.</div>;

    const renderList = (text) => {
        if (!text) return null;
        return (
            <ul className="list-disc pl-5 space-y-1 text-gray-600">
                {text.split('|').map((item, index) => <li key={index}>{item.trim()}</li>)}
            </ul>
        );
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="relative h-[300px] w-full flex items-center justify-center bg-gray-800 bg-cover bg-center"
                style={{ backgroundImage: `url('/banner-image.jpg')` }}>
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                <h1 className="relative z-10 text-white text-5xl font-bold uppercase text-center px-4">
                    {product.name || subCategory}
                </h1>
            </div>

            <div className="py-16 px-10 container mx-auto">
                <div className="grid md:grid-cols-2 gap-12 items-start bg-white p-8 rounded-lg shadow-md">
                    <div className="w-full h-[400px] flex items-center justify-center bg-gray-100 rounded-lg overflow-hidden">
                        <img
                            // FIX: Image domain handle kiya
                            src={product.image && product.image.startsWith('http') ? product.image : `${BASE_URL}${product.image}`}
                            alt={product.name}
                            className="w-full h-full object-contain"
                            onError={(e) => { e.target.src = 'https://via.placeholder.com/400'; }}
                        />
                    </div>

                    <div>
                        <h2 className="text-3xl font-bold text-blue-900 mb-6 border-l-4 border-orange-500 pl-4">Product Description</h2>
                        <p className="text-gray-700 text-lg leading-relaxed mb-6">{product.description}</p>

                        {product.features && <div className="mb-4"><h4 className="font-bold text-blue-800">Key Features:</h4>{renderList(product.features)}</div>}
                        {product.applications && <div className="mb-4"><h4 className="font-bold text-blue-800">Applications:</h4>{renderList(product.applications)}</div>}
                        {product.benefits && <div className="mb-4"><h4 className="font-bold text-blue-800">Benefits:</h4>{renderList(product.benefits)}</div>}

                        <button onClick={() => navigate('/enquiry')} className="mt-6 bg-orange-500 text-white px-8 py-3 rounded font-bold hover:bg-orange-600 transition">
                            ENQUIRY NOW
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubCategoryPage;